<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <label> Cadastro/Fornecedores</label>
    </div>
    <v-container fluid
      ><v-row align="center">
        <v-col>
          <v-btn v-if="isAllowed(4)" color="info" to="/fornecedor/criar" class="ma-2 white--text">
            NOVO
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-checkbox
            v-if="fornecedores.length > 0"
            v-model="showAtivo"
            label="MOSTRAR ITENS INATIVOS"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="fornecedores.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        class="elevation-1"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :options.sync="options"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        <template v-slot:item.cpf_Cnpj="{ item }">
          {{ formatCurrency(item.cpf_Cnpj) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(4)">Editar</span>
            <span v-else>Ver</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="show(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-file-search
              </v-icon>
            </template>
            <span>Visualizar em PDF</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { downloadLista, getPdf } from "../../../services/fornecedorService";
import { getUserRoles } from "@/services/loginService";
import { abrirJanelaPdf } from "@/services/pdfHelper";

export default {
  name: "listafornecedores",
  data() {
    return {
      loading: false,
      search: "",
      showAtivo: false,
      cpf_Cnpj:null,
      headers: [
        {
          text: "Id",
          align: "start",
          value: "id",
        },
        { text: "Nome", value: "nome" },
        { text: "CPF/CNPJ", value: "cpf_Cnpj" },
        { text: "Contato", value: "contato" },
        { text: "Status", value: "ativo" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
    };
  },
  computed: {
    ...mapState("fornecedor", ["fornecedores"]),
    filteredList() {
      const fornecedores = this.showAtivo === false
        ? this.fornecedores.filter((f) => f.ativo === true)
        : [...this.fornecedores];

      return fornecedores.sort((a, b) => Number(b.id) - Number(a.id));
    },
  },
  methods: {
    ...mapActions("fornecedor", [
      "atualizarFornecedores",
      "atualizarFornecedor",
    ]),
    editar(fornecedor) {
      this.atualizarFornecedor(fornecedor);
      if (this.isAllowed(4)) {
        this.$router.push({
          path: "/fornecedor/editar",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      } else {
        this.$router.push({
          path: "/fornecedor/ver",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      }
    },
    baixarlista() {
      downloadLista();
    },
    formatCurrency(valor) {
      if(valor.length === 14)
      {
        return valor.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
      else
      {
        return valor.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      }
    },
    show(item) {
      getPdf(
        item.id,
        abrirJanelaPdf()
      );
    },
    /*
    show(item) {
      obterPdf(
        item.id,
        item.nome,
        item.nomeFantasia,
        item.cpf_Cnpj,
        item.inscricaoEstadual,
        item.contato,
        item.celular,
        item.telefone,
        item.ramal,
        item.email,
        item.cep,
        item.endereco,
        item.numero,
        item.complemento,
        item.bairro,
        item.cidade,
        item.uf,
        item.ativo
      );
    },*/
    async obterLista() {
      this.loading = true;
      await this.atualizarFornecedores();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
  },
  watch: {
    "options.page"(p) {
      this.$router.replace({
        query: { ...this.$route.query, page: String(p) },
      });
    },
    "$route.query.page": {
      immediate: true,
      handler(val) {
        const qPage = parseInt(val, 10);
        const next = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
        if (next !== this.options.page) {
          this.options = { ...this.options, page: next };
        }
      },
    },
  },
  created: function () {
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }

    const qPage = parseInt(this.$route.query.page, 10);
    this.options.page = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
  },
};
</script>
